import Rollbar from 'rollbar';

const POST_CLIENT_ITEM_TOKEN = '8a087b250d11488daefd2952b73159d5';

let client: Rollbar | null = null;

export const initOutlookAddInRollbar = (): Rollbar => {
  if (client) {
    return client;
  }

  client = new Rollbar({
    accessToken: POST_CLIENT_ITEM_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    environment: import.meta.env.PROD ? 'production' : 'development',
    payload: {
      context: 'outlook-add-in',
    },
  });

  return client;
};

const officeDiagnostics = (): Record<string, unknown> => {
  const origin = {task_pane_origin: window.location.origin};
  if (typeof Office === 'undefined' || !Office.context) {
    return {...origin, office_available: false};
  }

  const diagnostics = Office.context.diagnostics;

  return {
    ...origin,
    office_available: true,
    office_host: diagnostics?.host,
    office_platform: diagnostics?.platform,
    office_version: diagnostics?.version,
  };
};

export const reportOutlookAddIn = (
  level: 'error' | 'warning' | 'info',
  message: string,
  extra?: Record<string, unknown>
): void => {
  initOutlookAddInRollbar()[level](message, {
    ...officeDiagnostics(),
    ...extra,
  });
};
